class PagesHome{

	constructor() {

		if( !document.querySelector('.page-template-template-home') )
			return;

		this.videoBaseline = document.querySelector('.home-video-baseline');
		this.pinVideoBaseline();
		this.textRevealBaseline();

		this.homeCta = document.querySelector('.home-cta');
		this.homeCtaHovered();

		this.homeStickyBannerCta = document.querySelector('.home-cta-image-text');
		if(this.homeStickyBannerCta) {
			this.homeHeaderStickyCta();
		}

		this.homePress = document.querySelector('.home-press');
		this.homePressSlider();

		this.invitToScroll = document.querySelector('.invit-to-scroll');
		this.invitToScroll.addEventListener("click", () => {
			smoother.scrollTo('.home-introduction', true);
		});

		this.homeKeys();

		resizeCallbacks.push(this);

	}

	homeHeaderStickyCta() {
		const { height } = this.homeStickyBannerCta.getBoundingClientRect();
		gsap.to('.header-main', {
			y: `-${height + 5}`,
			scrollTrigger: {
				trigger: '.home-video',
				start: `${height} top`,
				end:`${height + 5} top`,
				// markers: true,
				once: false,
				scrub: 1.1,
			}
		});
	}

	textRevealBaseline(){

		document.fonts.ready.then(() => {

			let text = document.querySelector('.home-video-baseline-end');
			new SplitText(text, {
				type: "lines,word,chars",
				linesClass: "lines",
				wordsClass: "word",
				charsClass: "char"
			});

			let highlightTl = gsap.timeline({
				scrollTrigger: {
					trigger: text,
					start: "top center+=" + this.videoBaseline.offsetHeight / 2,
					end: "top 25%",
					scrub: 1.1
				}
			});
			highlightTl.fromTo(text.querySelectorAll(".char"), {
				opacity: 0.4
			}, {
				opacity: 1,
				stagger: {
					each: 0.5
				},
				duration: 1
			});

		});

	}



	pinVideoBaseline(){

		if( document.querySelector('html').classList.contains('no-touchevents') ) {
			ScrollTrigger.create({
				trigger: this.videoBaseline,
				pin: true,
				start: 0,
				endTrigger: ".home-video-baseline-end",
				end: "top center+=" + this.videoBaseline.offsetHeight / 1.8,
				scrub: 1
			});
		}

	}

	homeCtaHovered(){

		let buttons = this.homeCta.querySelectorAll('.cta');
		buttons.forEach( (cta) => {

			this.setMouseAnimation(cta);
			cta.removeEventListener("mouseenter", this.startMouseEnterAnimation);
			cta.removeEventListener("mouseleave", this.startMouseLeaveAnimation);

		});

		if( mobileCheck.isMobile )
			return;

		buttons.forEach( (cta) => {

			cta.addEventListener('mouseenter', (e) => {
				this.startMouseEnterAnimation(e, cta);
			});

			cta.addEventListener('mouseleave', (e) => {
				this.startMouseLeaveAnimation(e, cta);
			});
		});

	}

	setMouseAnimation(cta){

		let section = cta.closest(".section");
		let bgColor = window.getComputedStyle(section).getPropertyValue("background-color");
		let btn = cta.querySelector(".follower");
		let windowWidth = window.innerWidth;

		gsap.set(btn, {
			'box-shadow': `1px 1px ${windowWidth}px ${windowWidth}px ${bgColor}, -1px -1px ${windowWidth}px ${windowWidth}px ${bgColor} inset`
		});

	}

	startMouseEnterAnimation(e, cta){

		let rect = cta.getBoundingClientRect();
		let btn = cta.querySelector(".follower");

		let section = cta.closest(".section");
		let bgColor = window.getComputedStyle(section).getPropertyValue("background-color");
		let windowWidth = window.innerWidth;

		let relX = (e.clientX - rect.left) - cta.offsetWidth / 2;
		let relY = (e.clientY - rect.top) - cta.offsetHeight / 2;

		gsap.set(btn, {
			x: relX,
			y: relY
		});
		gsap.to(btn, 0.8, {
			'box-shadow': `1px 1px ${windowWidth}px ${windowWidth}px ${bgColor}, -1px -1px 30px 30px ${bgColor} inset`
		});

	}

	startMouseLeaveAnimation(e, cta){

		let rect = cta.getBoundingClientRect();
		let btn = cta.querySelector(".follower");
		let windowWidth = window.innerWidth;

		let section = cta.closest(".section");
		let bgColor = window.getComputedStyle(section).getPropertyValue("background-color");

		let relX = (e.clientX - rect.left) - cta.offsetWidth / 2;
		let relY = (e.clientY - rect.top) - cta.offsetHeight / 2;

		gsap.set(btn, {
			x: relX,
			y: relY
		});
		gsap.to(btn, 0.8, {
			'box-shadow': `1px 1px ${windowWidth}px ${windowWidth}px ${bgColor}, -1px -1px ${windowWidth}px ${windowWidth}px ${bgColor} inset`
		});

	}

	homePressSlider(){

		let homePressInner = this.homePress.querySelector(".home-press-inner");
		let diff = this.homePress.offsetWidth - homePressInner.offsetWidth;

		gsap.to(homePressInner, {
			x : diff,
			scrollTrigger: {
				trigger: homePressInner,
				start : "top center",
				end : "top top",
				scrub: 1
			}
		});

	}

	homeKeys(){

		let arrayKeys = document.querySelector('.home-service-keys');
		let keys = document.querySelectorAll('.home-service-keys li');

		ScrollTrigger.create({
			trigger: arrayKeys,
			start: "top 75%",
			end: 99999,
			onEnter: () => {
				arrayKeys.classList.add("appeared");
			}
		});

		keys.forEach( (key, index) => {

			ScrollTrigger.create({
				trigger: key,
				start: "top 75%",
				end: 99999,
				onEnter: () => {
					key.classList.add("appeared");
				}
			});

			const splitTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: key,
					start: "top 75%",
					end: "bottom 0%",
				}
			});

			splitTimeline.from(key.querySelectorAll('.number span span, .label span span'), {
				duration: 1.5,
				yPercent: 150,
				ease: "power4",
				stagger: 0.15,
				autoAlpha: 0
			});
		});

	}

	resize(){
		this.homeCtaHovered();
	}

}